import React from 'react'
import { NavbarTwo } from '../components/Layout/Navbar'
import Footer from '../components/Layout/Footer'
import Certification from '../components/About/Certification'
import AboutIntro from '../components/About/AboutIntro'
import AboutMissionVision from '../components/About/AboutMissionVision'
import Clients from '../components/Home/Clients'

const Aboutus = () => {
  return (
    <div>
        <NavbarTwo />
        <div className='2xl:pt-[70px] pt-[55px] xl:pt-[65px] lg:pt-[60px]'>
        <AboutIntro />
        <AboutMissionVision />
        <Clients />
        <section id='certificates'><Certification /></section>
        <Footer />
        </div>
    </div>
  )
}

export default Aboutus;
